<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="api.orderFlagList"
      :placeholder="placeholder"
      :immediate="immediate"
      :query-params="queryParams"
      :no-page="true"
      :keys= "{searchKey: 'queryName' }"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    queryParams: Object,
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
  },
  setup() {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
      setField(str) {
        yxRef.value.setField(str);
      },
    };
  },
});
</script>
